import Http from "../api/http";

export default class ReportExample extends Http {
  constructor() {
    super();
  }


  reportExample_readReportExample() {
    return super.post("reportExample/readReportExample", ...arguments);
  }

}